import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { AuthFlowService } from '../auth/auth-flow.service';

/** Protected routes: a valid Shell session, otherwise sign-in with the requested URL kept as deeplink. */
export const authenticatedGuard: CanActivateFn = (_route, state) => inject(AuthFlowService).ensureSignedIn(state.url);
